import React from 'react';
import { Dialog, Flex, IconButton } from '@radix-ui/themes';
import { XMarkIcon } from '@heroicons/react/24/outline';

const Modal = ({ isOpen, onClose, title, children, size = 'medium' }) => {
  const maxWidthMap = {
    small: '400px',
    medium: '540px',
    large: '720px',
    xlarge: '900px',
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <Dialog.Content
        maxWidth={maxWidthMap[size]}
        className="glamour-footer"
        style={{
          width: 'min(calc(100vw - 20px), 100%)',
          maxHeight: 'calc(100dvh - 20px)',
          overflowY: 'auto',
          padding: 'clamp(16px, 4vw, 24px)',
          backgroundColor: '#fff',
          border: '1.5px solid var(--orange-5)',
          boxShadow: '0 25px 60px rgba(0,0,0,0.2)',
          borderRadius: '18px',
        }}
      >
        <Flex justify="between" align="center" mb="4">
          <Dialog.Title
            size="4"
            weight="semibold"
            style={{ margin: 0, color: 'var(--gray-12)', textAlign: 'left' }}
          >
            {title}
          </Dialog.Title>
          <Dialog.Close>
            <IconButton variant="ghost" color="gray" size="2" onClick={onClose}>
              <XMarkIcon style={{ width: '20px', height: '20px' }} />
            </IconButton>
          </Dialog.Close>
        </Flex>
        <div>{children}</div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default Modal;
